<template>
  <div
    v-if="!disabled && images.length > 0"
    ref="root"
    :class="[
      $style['image-swiper'],
      {
        [$style['image-swiper--disabled']]:
          !images || images.length < 2 || disabled
      },
      { [$style[`image-swiper--${aspectRatio}`]]: aspectRatio }
    ]"
    @touchend="show=false"
    @touchmove.passive="show = true"
    @mouseenter="show = true"
    @mouseleave="show = false">
    <div :class="$style['image-swiper__inner']">
      <div :class="$style['image-swiper__item']">
        <SmartImage
          :loading="loading"
          :width="480"
          :height="768"
          :src="images[0].mobile"
          sizes="100vw"
          :alt="alt" />
      </div>
      <div v-if="videos?.length && show" :class="$style['image-swiper__item']" :style="{'background-image': `url(${config.public.cdnURL}pictures/video_thumbs/${videos[0]}.webp)`}">
        <VideoPlayer :src="`${config.public.bunnyVideoURL}${videos[0]}/playlist.m3u8`" />
      </div>
      <div v-if="!videos?.length && images[1]?.mobile && show" :class="$style['image-swiper__item']">
        <SmartImage
          loading="lazy"
          :width="480"
          :height="768"
          :src="images[1].mobile"
          sizes="100vw"
          :alt="alt" />
      </div>
    </div>
  </div>
</template>
<script setup>
const config = useRuntimeConfig()
const root = ref(null)
const show = ref(false)

const props = defineProps({
  background: {
    type: [String, Boolean],
    default: false
  },
  aspectRatio: {
    type: String,
    default: null
  },
  disabled: {
    type: Boolean,
    default: false
  },
  alt: {
    type: String,
    required: false,
    default: ''
  },
  loading: {
    type: String,
    default: 'lazy'
  },
  images: {
    type: [Boolean, Array],
    required: true
  },
  videos: {
    type: Array,
    default: null
  },
  autoPlayVideo: {
    type: Boolean,
    default: false
  }
})

onMounted(() => {
  show.value = props.autoPlayVideo
})
onActivated(() => {
  show.value = props.autoPlayVideo
})

onUnmounted(() => {
  show.value = false
})
onDeactivated(() => {
  show.value = false
})
</script>
<style lang="scss" module>
.image-swiper {
  display: flex;
  height: auto;
  width: 100%;
  position: relative;
  z-index: 1;

  &::-webkit-scrollbar {
    display: none;
  }

  &__inner {
    display: flex;
    flex-flow: column wrap;
    height: 100%;
    width: 100%;
    z-index: 1;
    position: absolute;
  }

  &__item {
    aspect-ratio: 5/8;
    background-size: cover;
    width: 100%;
    height: 100%;
    z-index: 1;
    user-select: none;;
    position: absolute;
    top: 0;
    left: 0;

    img {
      color: transparent; // Hides text when image is not loaded yet
      width: 100%;
      height: 100%;
    }

    &:nth-child(2) {
      z-index: 2;
    }
  }

  &--disabled {
    pointer-events: none;
  }

  &--square {
    aspect-ratio: 1/1;

    .image-swiper__item img {
      object-fit: cover;
    }
  }
}
</style>
